<template>
  <div v-if="showAlert" class="new-report-alert">
    <p class="message">
      {{count}} additional report{{plural}} added
      on {{hgNewReportInfo.mostRecentUnviewedDate}}
    </p>
    <a class="btn-secondary new-report-link" :href="anchor">see new report{{plural}}</a>
  </div>
</template>

<script>
import NumberToWords from 'number-to-words';

export default {
  props: {
    hgNewReportInfo: {
      type: Object,
      required: true,
    },
    hgReportBlock: {
      type: Boolean,
      required: true,
    },
    hgReportAnchor: {
      type: String,
      required: true,
    },
  },
  computed: {
    count() {
      return NumberToWords.toWords(this.hgNewReportInfo.unviewedReportCount);
    },
    anchor() {
      return `#${this.hgReportAnchor}`;
    },
    plural() {
      return this.hgNewReportInfo.unviewedReportCount > 1 ? 's' : '';
    },
    showAlert() {
      const { totalReportCount } = this.hgNewReportInfo;
      const { unviewedReportCount } = this.hgNewReportInfo;

      return !(this.hgReportBlock // report is blocked, do not display
        || totalReportCount <= 1 // 1 or 0 reports, don't display
        || totalReportCount === unviewedReportCount // all reports are unviewed, do not display
        || unviewedReportCount === 0); // no unviewed reports, do not display
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/typography';

.message {
  font-size: 1.143rem;
  font-weight: $typography-weight-bold;
  margin-right: 30px;

  &:first-letter {
    text-transform: uppercase;
  }
}

p {
  margin-bottom: 0;
  padding: 10px 0;
}

.new-report-alert {
  background-color: #4a91e2;
  color: $theme-color-white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.new-report-link {
  border: solid 1px $theme-color-white;
  font-size: 17px;
  font-weight: $typography-weight-bold;
  padding: 5px 30px;
  text-transform: uppercase;
  vertical-align: middle;
}

@media all and (max-width: 655px) {
  .message {
    margin-right: 40px;
    padding-bottom: 20px;
  }
}
</style>
